import InvisibleRecaptcha from './InvisibleRecaptcha';

export default InvisibleRecaptcha;



// WEBPACK FOOTER //
// ./src/components/molecules/InvisibleRecaptcha/index.js